import styled from 'styled-components';
import { spacing } from '~/constants/spacing';

export const BackToPageTopContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: ${spacing.xsm};
  cursor: pointer;
`;
